<glxy-form-field [required]="required()">
  @if (title()) {
    <glxy-label>
      {{ title() }}
    </glxy-label>
  }
  @if (titleHint()) {
    <glxy-label-hint>
      {{ titleHint() }}
    </glxy-label-hint>
  }
  <glxy-rich-text-editor
    #textEditor
    class="text-editor"
    elementId="{{ elementId() }}"
    [formControl]="inputControl"
    [plugins]="false"
    [toolbar]="false"
    [styleOverride]="
      'p, body {margin: 4px; white-space: nowrap; overflow-x: auto; overflow-y: hidden; scrollbar-width: none; -ms-overflow-style: none;} p::-webkit-scrollbar, body::-webkit-scrollbar {display: none;}'
    "
    [enableThemes]="true"
  >
  </glxy-rich-text-editor>
  <mat-icon
    class="form-field-icon"
    glxySuffix
    (click)="openDialog()"
    [glxyTooltip]="'EMAIL_BUILDER.DYNAMIC_COMPONENT_SELECTOR.INSERT_DYNAMIC_CONTENT' | translate"
  >
    data_object
  </mat-icon>
</glxy-form-field>
